import Naluri from '~/common/api/naluri';
import { Socket } from 'phoenix';
import {
  CHAT_CONNECTED,
  CHAT_CONNECTION_FAILED,
  CHAT_DISCONNECTED,
  USER_TYPING_MESSSAGE,
  USER_STOP_TYPING_MESSSAGE,
  // RECEIVE_MESSAGE,
  CHAT_BEGIN_GET_MESSAGES,
} from './constants';
import { COMMON_SIDEBAR_RESET_UNREAD } from '~/features/common/redux/constants';
// import { DELETE_MESSAGE } from '~/features/chat/redux/constants';
// import { getStarredMessages } from './actions';
import { getApiHost, getAppSecure, logoutWithRedirectBack } from '~/common/utils';
import { currentTokenInfo } from '~/common/auth';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga

export function connectToChat(streamId) {
  return async dispatch => {
    // const { common } = getState();
    dispatch({
      type: CHAT_BEGIN_GET_MESSAGES,
    });

    let token, userId;

    await currentTokenInfo()
      .then(res => {
        token = res.token
        userId = res.userId
      })
      .catch(err => {
        if (err.code === 'NotAuthorizedException') {
          // If refresh token, or current session is expired,
          // Logout and redirect users.
          logoutWithRedirectBack();
        }
      });

    const socket = new Socket(getAppSecure('websocket') + getApiHost() + '/socket', {
      params: { token },
    });
    const channel = socket.channel('one_on_one_chat:' + streamId, {});

    socket.connect();

    channel
      .join()
      .receive('ok', resp => {
        Naluri.get(`/api/expert/${streamId}/history?page=1`).then(history => {
          dispatch({ type: COMMON_SIDEBAR_RESET_UNREAD, channelId: streamId });
          dispatch(chatConnected(channel, socket, streamId, history, userId));
        });
      })
      .receive('error', resp => {
        dispatch(chatConnectionFailed());
      });

    channel.onClose(e => dispatch(chatDisconnected()));

    socket.onClose(e => dispatch(chatDisconnected()));

    // channel.on('new:message', message => {
    //   dispatch({ type: RECEIVE_MESSAGE, message: message });

    //   if (message.user_id !== userId) {
    //     channel.push('read:message', message);
    //   }
    // });

    // channel.on('nlp:message', message => {
    //   dispatch({ type: RECEIVE_MESSAGE, message: message });
    // });

    // channel.on('user:typing', user => {
    //   dispatch({ type: USER_TYPING_MESSSAGE, user: user });
    //   setTimeout(() => dispatch({ type: USER_STOP_TYPING_MESSSAGE, user: user }), 5000);
    // });

    // channel.on('presence_diff', payload => {
    //   let joins = Object.keys(payload.joins);
    //   let leaves = Object.keys(payload.leaves);

    //   if ((!isEmpty(joins) && !isEmpty(leaves)) || isEqual(joins, leaves)) {
    //     joins = Object.keys(Presence.syncDiff([], payload));
    //     dispatch(usersJoined(joins));
    //     dispatch(usersLeft([]));
    //   } else {
    //     dispatch(usersJoined(joins));
    //     dispatch(usersLeft(leaves));
    //   }
    // });

    // channel.on('delete:messages', payload => {
    //   const deletedMsg = payload.deleted_message_ids;

    //   dispatch({ type: DELETE_MESSAGE, id: deletedMsg });
    // });
  };
}

export function userTyping(user) {
  return async dispatch => {
    dispatch({ type: USER_TYPING_MESSSAGE, user: user });
    setTimeout(() => dispatch({ type: USER_STOP_TYPING_MESSSAGE, user: user }), 5000);
  };
}

export function leaveChannel() {
  return (dispatch, getState) => {
    const channel = getState().chat.chatState.channel;
    channel.push('leave_channel', {});
  };
}

export function chatConnected(channel, socket, streamId, history, userId) {
  return { type: CHAT_CONNECTED, channel, socket, streamId, history, userId };
}

export function chatConnectionFailed() {
  return { type: CHAT_CONNECTION_FAILED };
}

export function chatDisconnected() {
  return { type: CHAT_DISCONNECTED };
}

export function reducer(state, action) {
  switch (action.type) {
    case CHAT_BEGIN_GET_MESSAGES:
      return {
        ...state,
        messagesPending: true,
      };

    case CHAT_CONNECTED:
      let { type, history, ...data } = action;

      return {
        ...state,
        chatState: {
          ...state.chatState,
          ...data,
          ...history,
          connected: true,
          connectionError: false,
          connectionDisconnected: false,
        },
        messagesPending: false,
      };

    case CHAT_CONNECTION_FAILED:
      return {
        ...state,
        chatState: {
          ...state.chatState,
          connected: false,
          connectionError: true,
          connectionDisconnected: false,
        },
      };

    case CHAT_DISCONNECTED:
      return {
        ...state,
        chatState: {
          ...state.chatState,
          connected: false,
          connectionError: false,
          connectionDisconnected: true,
        },
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/chat/redux/chatState.js